/** SHA-1 hex digest of `plain` (UTF-8), matching GNU `sha1sum` on the same bytes. */
export async function hashLocalPassword(plain: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(plain));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}
